import React from 'react';
import styled from '@emotion/styled';

import Grid from '../../elements/Grid';
import phone from '../../images/about/phone.png';
import smartdrawGraph from '../../images/smartdraw/graph.svg';
import { theme } from '@kindur/components';
import colors from '../../styles/colors';

const Section = styled(Grid)`
  grid-gap: 2rem;
  padding: 4rem 5rem 5rem;
  margin: 0 auto;
  max-width: 90rem;

  ${theme.breakpoints.tabletDown} {
    grid-gap: 2rem 0;
    padding: 2rem 2rem 4rem;
  }
`;

const Column = styled('div')`
  position: relative;

  &:last-child {
    align-items: center;
    display: flex;
  }

  ${theme.breakpoints.largeDesktopUp} {
    &:last-child {
      justify-self: end;
      padding-right: 18rem;
    }
  }
`;

const Title = styled('h1')`
  font-family: 'DM Sans', sans-serif;
  font-size: 2.5rem;
  font-weight: 700;
  line-height: 3rem;
  margin-bottom: 1em;
`;

const Copy = styled('div')`
  font-family: 'DM Sans', sans-serif;
  font-size: 1.125rem;
  line-height: 1.5em;
  white-space: pre-line;
`;

const Phone = styled('img')`
  width: 18rem;

  ${theme.breakpoints.desktopDown} {
    width: 16rem;
  }

  ${theme.breakpoints.tabletDown} {
    margin-left: 10%;
    width: 14rem;
  }

  @media (max-width: 500px) {
    margin-left: 0;
    width: 12rem;
  }
`;

const Graph = styled('img')`
  left: 12rem;
  position: absolute;
  top: 12rem;
  width: 24rem;

  ${theme.breakpoints.desktopDown} {
    left: 10rem;
    top: 40%;
    width: 20rem;
  }

  ${theme.breakpoints.tabletDown} {
    left: 35%;
    top: 30%;
    width: 18rem;
  }

  @media (max-width: 500px) {
    left: unset;
    right: 0;
    top: 8rem;
    width: 16rem;
  }
`;

const Link = styled('a')`
  color: ${colors.DarkGreen};
`;

const WhoWeAre = () => {
  return (
    <Section>
      <Column>
        <Title>Who We Are</Title>
        <Copy>
          Over the last several weeks, the world has changed around us. Our retirements, once secure, feel less so, and we have more questions than answers. To meet this moment, we will help Baby Boomers navigate these times, make smart decisions for retirement, and help them achieve their goals.<br/><br/>
          Kindur is proud to add <Link href='https://silvur.app.link/KZkraVfqI5'>Silvur</Link>, the first retirement app dedicated to Baby Boomers, to its family of brands and tools. Silvur will leverage Kindur’s SmartDraw technology to estimate Baby Boomers’ financial picture throughout retirement for them to feel financially aware of the future.<br/><br/>
          Kindur’s values are deeply-rooted throughout its brands and tools: Silvur and SmartDraw. With one purpose in mind, Kindur is dedicated to securely guiding Baby Boomers through their lifetime achievement—retirement.
        </Copy>
      </Column>
      <Column>
        <Phone src={phone} alt='Phone with Silvur app'/>
        <Graph src={smartdrawGraph} alt='SmartDraw graph'/>
      </Column>
    </Section>
  );
};

export default WhoWeAre;
